import template from './back-to-top.html';
export default template.trim();
